import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AnalyticEvent, AnalyticsBloc, AnalyticsPageName } from '@kanalytics';
import { EligibilityCandidate } from '@kp/eligibility/eligibility-candidate.model';
import { WorkbookBloc } from '@kp/workbook/workbook.bloc';
import { Status } from '@ktypes/models';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export interface WorkbookEmailFormValues {
  email: string;
}

@Component({
  selector: 'kp-screen-workbook-review',
  templateUrl: './screen-workbook-review.component.html',
  styleUrls: ['./screen-workbook-review.component.scss'],
})
export class ScreenWorkbookReviewComponent implements OnInit, OnDestroy {
  candidate: EligibilityCandidate;
  email: UntypedFormControl;
  emailForm: UntypedFormGroup;
  isAddressInvalid = false;
  error = false;

  private _destroy$ = new Subject<void>();

  constructor(private _analyticsBloc: AnalyticsBloc, private _router: Router, private _workbookBloc: WorkbookBloc) {}

  ngOnInit() {
    this._analyticsBloc.sendEvent(
      this._analyticsBloc.createEventFromInteraction({
        page: AnalyticsPageName.workbook,
        event: AnalyticEvent.workbook_review_shown,
      })
    );
    this.email = new UntypedFormControl('', [Validators.pattern(/^.+@.+$/)]);
    this.emailForm = new UntypedFormGroup({
      email: this.email,
    });

    this._workbookBloc.workbookCandidate$.pipe(takeUntil(this._destroy$)).subscribe((eligibilityCandidate) => {
      if (eligibilityCandidate) {
        this.candidate = eligibilityCandidate;
        this.email.setValue(eligibilityCandidate.email);
        this.isAddressInvalid = !(
          this.candidate?.addressLine &&
          this.candidate?.city &&
          this.candidate?.region &&
          this.candidate?.postalCode
        );
      }
    });

    this._workbookBloc.workbookRequestStatus$.pipe(takeUntil(this._destroy$)).subscribe((request) => {
      if (request?.status === Status.done) {
        void this._router.navigate(['/welcome/workbook/confirmed']);
      } else if (request?.status === Status.error) {
        this.error = true;
      }
    });
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }

  completeOrder(formValues: WorkbookEmailFormValues) {
    this.candidate.email = formValues.email;
    this._workbookBloc.updateCandidate(this.candidate);
    this._workbookBloc.createWorkbookRequest(this.candidate);
  }
}
